<template>
  <a-layout-header class="header">
    <div>
      <img src="/logo-ngadomoe.png" alt="ngadomoe-logo" />
    </div>
    <div v-if="user">
      <a-dropdown>
        <a class="ant-dropdown-link" @click.prevent>
          <UserOutlined class="user-icon" />
          {{ username }}
        </a>
        <template #overlay>
          <a-menu>
            <a-menu-item>
              <a-button
                type="link"
                :icon="h(LogoutOutlined)"
                @click.prevent="handleLogout"
                >Logout</a-button
              >
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
  </a-layout-header>
</template>

<script src="./index.js"></script>
<style src="./style.less" lang="less" scoped></style>
